<template>
  <el-dialog
    append-to-body=""
    title="箱码生产"
    :visible.sync="visible"
    width="360px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="produceInfo"
      :rules="rules"
      label-width="90px">
      <el-form-item
        label="生产数量:"
        prop="setCount">
        <el-input-number
          v-model="produceInfo.setCount"
          style="width:220px"
          :min="1"
          :max="200000"
          :precision="0"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="addsetsegment">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LabelSetProduceModal',
  components: { },
  props: {
    fetch: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      produceInfo: {
        setCount: undefined,
        corratio: 0
      },
      rules: {
        setCount: [
          { required: true, message: '请输入生产数量', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    init() {
      this.toggleModal(true)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.produceInfo = {
        setCount: undefined,
        corratio: 0
      }
    },
    addsetsegment() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('label/addsetsegment', {
            payload: {
              ...this.produceInfo,
              isPreassign: 1,
              refVendorId: this.userInfo.orgId,
              tagType: this.userDetail.tagTypes
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.fetch && this.fetch()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
